import useEntity from "../../hooks/useForestOwner";
import ForestOwnerDetail from "../../components/forestOwner/ForestOwnerDetail/ForestOwnerDetail";
import ForestOwnerScoped from "../../components/forestOwner/ForestOwnerDetail/ForestOwnerScoped";
import ForestOwnerTabs from "../../components/forestOwner/ForestOwnerDetail/ForestOwnerTabs";
import { useGetForestOwnerQuery } from "../../apis/ForestOwner.api";
import { PrimaryForestOwner } from "../../types/models/ForestOwner";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ForestOwnerDetailPage = () => {

    useTitle(t`Details Forest Owner`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { forestOwnerId: id } = useParams();

    const { data, refetch } = useGetForestOwnerQuery(PrimaryForestOwner.fromPath(id))
    const { deleteForestOwner } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteForestOwner(data, '..')
    }, [data, deleteForestOwner])

    if (id === 'scoped') {
        return (<ForestOwnerScoped/>)
    }

    return (
        <Box data-testid="ForestOwner-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ForestOwnerDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ForestOwners/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="ForestOwner-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ForestOwners/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="ForestOwner-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ForestOwnerTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ForestOwnerDetailPage;
